import { PathName } from './customerSupportWidget/types';

export const parsePathname = (pathname: string, isEmbedded = false) => {
  const splitUrl = pathname.split('/');
  const currentPathName = isEmbedded ? splitUrl[2] : splitUrl[1];
  const patientId = (isEmbedded ? splitUrl[3] : splitUrl[2]) ?? null;
  const imageId = splitUrl.length > 3 ? splitUrl[splitUrl.length - 1] : null;
  let currentPage: PathName;
  if (currentPathName === 'annotator' && imageId) {
    currentPage = PathName.single_image_view;
  } else if (currentPathName === 'annotator' && patientId) {
    currentPage = PathName.fmx;
  } else {
    currentPage = PathName.other;
  }
  return { currentPage, patientId, imageId };
};
